<template>
  <div class="Sustainable">
    <div class="Sustainable_box">
      <div class="Sustainable_box_left">
        <div class="Sustainable_box_content">
          <div class="name">
            <div class="active_status">
              <div class="hr_"></div>
            </div>
            <div class="title">可持续发展目标科学</div>
          </div>
          <div class="info">可持续发展目标新闻</div>
          <div class="arrows">
            <div class="sdg_btn_box_i">
              <div class="arrows_hr"></div>

              <div class="sdg_btn_box_i_posi">
                <i class="iconfont icon-jiantou"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="Sustainable_box_content">
          <div class="name">
            <div class="active_status">
              <div class="hr_"></div>
            </div>
            <div class="title">SDGs最佳实践</div>
          </div>
          <div class="info">可持续发展目标新闻</div>
          <div class="arrows">
            <div class="sdg_btn_box_i">
              <div class="arrows_hr"></div>

              <div class="sdg_btn_box_i_posi">
                <i class="iconfont icon-jiantou"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="Sustainable_box_content">
          <div class="name">
            <div class="active_status">
              <div class="hr_"></div>
            </div>
            <div class="title">可持续发展目标知识库</div>
          </div>
          <div class="info">知识库总览</div>
          <div class="arrows">
            <div class="sdg_btn_box_i">
              <div class="arrows_hr"></div>

              <div class="sdg_btn_box_i_posi">
                <i class="iconfont icon-jiantou"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="Sustainable_box_right">
          <!-- <div class="Sustainable_box_right_content"> -->
              <div class="Sustainable_box_img">
                 <img src="../../../assets/image/Index/Sustainable1.jpg" alt="" />
                 <div class="name">
                     经济
                 </div>
              </div>
              <div class="Sustainable_box_img">
                  <img src="../../../assets/image/Index/Sustainable2.jpg" alt="" />
                 <div class="name">
                     统计数据
                 </div>
              </div>
              <div class="Sustainable_box_img">
                  <img src="../../../assets/image/Index/Sustainable3.jpg" alt="" />
                 <div class="name">
                     报告
                 </div>
              </div>
              <div class="Sustainable_box_img">
                  <img src="../../../assets/image/Index/Sustainable4.jpg" alt="" />
                 <div class="name">
                     解决问题
                 </div>
              </div>

          <!-- </div> -->

      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
.Sustainable {
  height: 650px;
  width: 100%;
  background: #269247;
  .Sustainable_box {
    width: 1280px;
    height: 100%;
    margin: auto;
    display: flex;
    flex-direction: row;
    .Sustainable_box_left {
      // background: #ccc;
      width: 400px;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;

      .Sustainable_box_content {
        cursor: pointer;
        height: 130px;
        &:hover .hr_ {
          display: block;
        }
        .name {
          display: flex;
          flex-direction: row;
          align-items: center;
          height: 40px;
          .active_status {
            width: 20px;
            height: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;

            .hr_ {
              width: 4px;
              height: 26px;
              display: none;
              background: #fff;
            }
          }
          .title {
            font-size: 20px;
            font-weight: 600;
            color: #fff;
          }
        }
        .info {
          font-size: 14px;
          padding-left: 20px;
          padding-top: 4px;
          // font-weight: 600;
          color: #fff;
        }
        &:hover .arrows_hr {
          width: 60px !important;
        }
        &:hover .name .hr_ {
          display: block !important;
        }
         &:hover .arrows {
            margin-left: 0 !important;
        }

        .arrows {
            margin-top: 6px;
            padding-left: 20px;
            margin-left: 13px;
          .sdg_btn_box_i {
            width: 120px;
            height: 40px;
            display: flex;
            flex-direction: row;
            align-items: center;
            // margin-left: 20px;

            .arrows_hr {
              width: 0px;
              height: 4px;
              // margin-left: -30px;
              background: #fff;
              transition: 0.3s;
            }

            .sdg_btn_box_i_posi {
              position: relative;
              i {
                font-weight: 600;
                font-size: 22px;
                color: #fff;
                position: absolute;
                left: -13px;
                top: -11px;
              }
            }
          }
        }
      }
    }
    .Sustainable_box_right{
        flex: 1;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-content:flex-start ;
        // align-items: flex-start;
        .Sustainable_box_img{
            width:  440px;
            height: 300px;
            overflow: hidden;
            position: relative;
            img{
                width: 100%;
                height: 100%;
            }
            .name{
                position: absolute;
                bottom: 10px;
                left: 10px;
                font-size: 18px;
                font-weight: 600;
                color: #fff;
            }
        }
    }
  }
}
</style>